/**
 * State of the confirm modal
 *
 * @export
 * @class State
 */
export class State {
	title: string;
	body: string;
	okLabel: string;
	cancelLabel: string;
	confirm: string;
	isAccent: boolean;
}

export const initialState: State = {
	title: '',
	body: '',
	okLabel: '',
	cancelLabel: 'Cancel',
	confirm: null,
	isAccent:true
};
